import React, { Component } from 'react';
import { Container } from 'reactstrap';


class Breadcrumb extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    //show the new breadcrumb for only support page
    const isSupportPage = window.location.href.indexOf("/support") > 0 || window.location.href.indexOf("/helpandsupport/") > 0;
    const navigateToHome = window.location.href.indexOf("/business") > 0 ? "/business" : "/";
    //console.log("breadcrumb com props >>>> ", this.props + "\n isSupportPage >>> ", isSupportPage);
    let bcChevron, bcBackground, bcLinkText, bcActiveText;
    (location.pathname.indexOf("/business/") >= 0) ?
      (bcChevron = "icon-arrowright-white", bcBackground = "breadcrumb-with-bg-business", bcLinkText = "item-text-business", bcActiveText = "current-page-link-business")
      :
      (bcChevron = "icon-arrowright-white", bcBackground = "breadcrumb-with-bg", bcLinkText = "item-text", bcActiveText = "current-page-link")
    return (
      <div>
        {
          (isSupportPage) ?
            (
              <div className={"eir-breadcrumb " + bcBackground}>
                <ul className="container">
                  <li>
                    <a href={navigateToHome} className="align-items-center">
                      <span className={bcLinkText}>Home</span>
                      <span className={"eir-icon eir-icon--sm chevron-alignment mr-2 " + bcChevron} />
                    </a>
                  </li>
                  {this.props.links.map((item, index) =>
                    <li key={index}>
                      {(index != this.props.links.length - 1) ?
                        (
                          <a href={item.link} className="align-items-center">
                            <span className={bcLinkText}>{item.text}</span>
                            <span className={"eir-icon eir-icon--sm chevron-alignment mr-2 " + bcChevron} />
                          </a>
                        )
                        :
                        <span className={bcActiveText}>{item.text}</span>
                      }

                    </li>
                  )}
                </ul>
              </div>
            )
            :
            (
              <Container className="mb-5 mt-5 eir-breadcrumb">
                <a href={this.props.links[0].link} className="d-flex justify-content-start align-items-center">
                  <span className="eir-icon eir-icon--sm icon-arrowleft-secondary mr-2" />
                  <span>{this.props.links[0].text}</span>
                </a>
              </Container>
            )
        }
      </div>
    );
  }
}

export default Breadcrumb;
